import { Component, Input, ViewChild } from '@angular/core';
import {
  EvidenceValue,
  IEvidenceSnapshotModel
} from 'src/app/shared/models/credential/personScenarioEvidenceDetails';
import { CustomFieldEditorModalComponent } from '../../../../../shared-app-portal/components/custom-field-editor-modal/custom-field-editor-modal.component';
import { GenericAttributeServiceFactory } from 'src/app/shared/services/genericAttributeServiceFactory.service';

@Component({
  selector: 'evidence-snapshot',
  templateUrl: './evidence-snapshot.component.html',
  styleUrls: ['./evidence-snapshot.component.scss'],
  standalone: false
})
export class EvidenceSnapshotComponent {
  constructor(private factory: GenericAttributeServiceFactory) {}

  @Input() scenarioId: string;

  @Input()
  evidence: IEvidenceSnapshotModel;

  @Input()
  isEditable: boolean;
  //** could be entityCredentialApplicationId OR entityRequirementId */
  @Input()
  identifier: string;
  /** only used with fields of type complex fields */
  @Input()
  showAllFields: boolean;
  @Input()
  openEvidenceFile: (filename: string, evidence: IEvidenceSnapshotModel) => void;

  openEvidenceImageInS3 = (fileName: EvidenceValue, evidence: IEvidenceSnapshotModel) =>
    this.openEvidenceFile(fileName as string, evidence);

  @ViewChild(CustomFieldEditorModalComponent, { static: true }) //
  dialog: CustomFieldEditorModalComponent;

  openEditAttributeModal = async () => {
    const { existingValue, service } = await this.buildGenericAttributeService();
    this.dialog.open(existingValue, service);
  };
  //!this.specialtyEvidenceModel.evidenceSnapshotTakenDate &&
  private get _isEditable(): boolean {
    return (
      this.isEditable &&
      (this.evidence.evidenceType === 'Skill' || this.evidence.evidenceType === 'CustomField')
    );
  }

  showEditButton = () => this._isEditable && this.evidence?.evidenceValue?.length;
  showAddButton = () => this._isEditable && !this.evidence?.evidenceValue?.length;

  private buildGenericAttributeService = () => {
    if (this.scenarioId) {
      return this.factory.BuildForEntityOnEvidence(
        this.scenarioId,
        this.identifier,
        this.evidence.lookupValue
      );
    }
    return this.factory.BuildForEntityOnSpecialtyEvidence(
      this.identifier,
      this.evidence.lookupValue
    );
  };

  async onClearField() {
    const { service } = await this.buildGenericAttributeService();

    service.deleteAttribute();
  }
}
